import { BrowserAgent } from "@newrelic/browser-agent/loaders/browser-agent";

const options = {
  init: {
    distributed_tracing: { enabled: true },
    privacy: { cookies_enabled: true },
    ajax: { deny_list: ["bam.nr-data.net"] },
    // page_view_timing: { enabled: true }, spa: { enabled: true }
  },
  info: {
    beacon: "bam.nr-data.net",
    errorBeacon: "bam.nr-data.net",
    licenseKey: import.meta.env.VITE_NR_LICENSE_KEY,
    applicationID: import.meta.env.VITE_NR_APP_ID,
    sa: 1,
  },
  loader_config: {
    accountID: "7071682",
    trustKey: "7071682",
    agentID: "1431865256",
    licenseKey: "NRJS-a18011fe0224c6eab5e",
    applicationID: "1431865256",
  },
};

// Booting agent immediately
new BrowserAgent(options);

// Optional : export window.newrelic typings via @types/new-relic-browser
declare global {
  interface Window {
    newrelic: any;
  }
}
